import { render, staticRenderFns } from "./abnormalList.vue?vue&type=template&id=b655ede2&scoped=true"
import script from "./abnormalList.vue?vue&type=script&lang=js"
export * from "./abnormalList.vue?vue&type=script&lang=js"
import style0 from "./abnormalList.vue?vue&type=style&index=0&id=b655ede2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b655ede2",
  null
  
)

export default component.exports